import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Box, Typography, Stack } from '@mui/material';
// import { BarChart, Computer, PieChart } from "@mui/icons-material";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ComputerIcon from '@mui/icons-material/Computer';
import PieChartIcon from '@mui/icons-material/PieChart';
import Carousel from 'react-bootstrap/Carousel';
import "../CSS/AppPromoSection.css";

const AppPromoSection = () => {
  return (
    <Container fluid className="app-promo-section py-5">
      <Row className="align-items-center mb-4">
        
          

      <Box
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 5,
        }}
      >
        {/* Left Content */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#a5c94d', mb: 4, textAlign: { xs: 'center', md: 'left' } }}>
            Get the App & Invest Hassle Free
          </Typography>

          <Stack spacing={3}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <ShowChartIcon sx={{ fontSize: 40, color: '#a5c94d' }} />
              <Box>
                <Typography variant="h6" fontWeight={700} textAlign="left">INVEST</Typography>
                <Typography variant="body2" textAlign="left">Invest in Mutual Fund schemes.</Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="flex-start">
              <ComputerIcon sx={{ fontSize: 40, color: '#a5c94d' }} />
              <Box>
                <Typography variant="h6" fontWeight={700} textAlign="left">ACCESS</Typography>
                <Typography variant="body2" textAlign="left">Access to hand-picked list of selected funds.</Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="flex-start">
              <PieChartIcon sx={{ fontSize: 40, color: '#a5c94d' }} />
              <Box>
                <Typography variant="h6" fontWeight={700} textAlign="left">TRACK</Typography>
                <Typography variant="body2" textAlign="left">Check your portfolio anytime anywhere.</Typography>
              </Box>
            </Stack>
          </Stack>

          <Typography sx={{ mt: 4, fontWeight: 500, textAlign: { xs: 'center', md: 'left' } }}>
            Download the App Now!
          </Typography>

          <Stack direction="row" spacing={2} mt={2} justifyContent={{ xs: 'center', md: 'flex-start' }}>
          <a href="https://play.google.com/store/apps/details?id=com.value.fundz" target="_blank" rel="noopener noreferrer">
            <img src={require('../Images/google_play.jpg')} alt="Google Play" style={{ height: '50px' }} />
          </a>  
          <a href="https://apps.apple.com/in/app/valuefundz/id6740617316" target="_blank" rel="noopener noreferrer">
            <img src={require('../Images/app_store.jpg')} alt="App Store" style={{ height: '50px' }} />
          </a>  
          </Stack>
        </Box>
        {/* Right Image */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
        <Carousel>
            <Carousel.Item>
              <img
                className="d-block mx-auto"
                src={require("../Images/AppImage1.png")}
                style={{
                  height: '600px',
                  width: '100%',
                  objectFit: 'contain',
                  backgroundColor: '#f8f8f8', // Optional: fills space around the image
                  padding: '10px', // Optional: avoid image touching edges
                }}
                alt="First slide"
              />
              <br />
            </Carousel.Item>
            <Carousel.Item>
            <img
                className="d-block mx-auto"
                src={require("../Images/AppImage2.png")}
                style={{
                  height: '600px',
                  width: '100%',
                  objectFit: 'contain',
                  backgroundColor: '#f8f8f8', // Optional: fills space around the image
                  padding: '10px', // Optional: avoid image touching edges
                }}
                alt="Second slide"
              />
              <br />
              
            </Carousel.Item>
            <Carousel.Item>
            <img
                className="d-block mx-auto"
                src={require("../Images/AppImage3.png")}
                style={{
                  height: '600px',
                  width: '100%',
                  objectFit: 'contain',
                  backgroundColor: '#f8f8f8', // Optional: fills space around the image
                  padding: '10px', // Optional: avoid image touching edges
                }}
                alt="Third slide"
              />
              <br/>
            </Carousel.Item>
            <Carousel.Item>
            <img
                className="d-block mx-auto"
                src={require("../Images/AppImage4.png")}
                style={{
                  height: '600px',
                  width: '100%',
                  objectFit: 'contain',
                  backgroundColor: '#f8f8f8', // Optional: fills space around the image
                  padding: '10px', // Optional: avoid image touching edges
                }}
                alt="Fourth slide"
              />
              <br />
              
            </Carousel.Item>
          </Carousel>
        </Box>
      </Box>
      </Row>

      <Row>
      <Box
        sx={{
          width: '100%',
          py: 6,
          px: { xs: 3, md: 10 },
          background: 'linear-gradient(to right, #ffffff, #a5c94d)',
          // background: "#a5c94d",
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
        }}
      >
        {/* Text Section */}
        <Box sx={{ maxWidth: 600 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Would you like to start investing with us?
          </Typography>
          <Typography variant="body1" style={{color: "black"}}>
            With our expertise in finance and guidance from our dedicated financial consultation in Jaipur, investing with us is simpler and more straightforward than ever before.
          </Typography>
        </Box>

        {/* QR Code Section */}
        <Stack direction="row" spacing={3}>
        <a href="https://play.google.com/store/apps/details?id=com.value.fundz" target="_blank" rel="noopener noreferrer">
          <img src={require("../Images/Play Store.png")} alt="Google Play QR" style={{ height: 120 }} />
        </a>  
        <a href="https://apps.apple.com/in/app/valuefundz/id6740617316" target="_blank" rel="noopener noreferrer">
          <img src={require("../Images/App Store.png")} alt="App Store QR" style={{ height: 120 }} />
        </a>
        </Stack>
      </Box>
      </Row>
    </Container>
  );
};

export default AppPromoSection;
